import { PayloadAction } from '@reduxjs/toolkit';
import { Quotation, QuotationParams } from 'src/types';
import { State } from './slice';
import { initialQuotationState } from 'src/views/quotation/constants';

const reducers = {
  setChangeCategoryTypeRowAction: (
    state: State,
    { payload }: PayloadAction<Quotation[]>
  ) => {
    state.quotationData = payload;
  },

  setChangeQuotationProductAction: (
    state: State,
    { payload }: PayloadAction<Quotation[]>
  ) => {
    state.quotationData = payload;
  },

  resetQuotationAction: (state: State) => {
    state.quotationData = initialQuotationState;
    state.template.templateDetails = {
      id: 0,
      name: ''
    };
  },

  setQuotationParams: (
    state: State,
    { payload }: PayloadAction<QuotationParams>
  ) => {
    state.quotationProductParams = payload;
  },

  resetProductOptionsAction: (state: State) => {
    state.product.productOptions = [];
  },

  setTotalAmount: (state: State, { payload }: PayloadAction<number>) => {
    state.totalAmount = payload;
  },

  setQuotationBranchID: (state: State, { payload }: PayloadAction<number>) => {
    state.branch_id = payload;
  },

  setQuotationClearBranch: (state: State) => {
    state.branch_id = undefined;
  }
};

export default reducers;
